export default __webpack_public_path__ + "static/media/section3.2dcb96f6.jpg";